
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button-message.vue";
import CustomRequestModal from "@/components/requests/CustomRequestModalNew.vue";
import {
  Custom_Request_Insert_Input,
  Project,
} from "@/generated/graphql";
import { NOTIFICATION } from "@/entities/Events";
import Message from "@/data/notificationsMessages";
import CustomRequestFormData from "@/entities/customRequests/CustomRequestFormData";
import CREATE_CUSTOM_REQUEST from "@/apollo/requests/CreateCustomRequest.gql"
import { customRequestCreatedMessage } from "@/data/successMessages";
import PlusIcon from "@/components/icons/PlusIcon.vue";

interface CreateRequestArgs {
  customRequestFormData: CustomRequestFormData,
  projectId: string,
  companyId: string,
  currentUserId: string,
}

interface ReflectUiActionArgs {
  action: () => Promise<void>,
  actionSuccess: () => void,
}

@Component({
  components: { PlusIcon, CustomRequestModal, UiButton }
})
export default class ProjectCustomRequest extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Object, required: true }) readonly project!: Project;

  modalShown: boolean = false;
  processing: boolean = false;

  get initialSkillIds(): number[] {
    return this.project.project_skills.map(({ skill }) => skill.id);
  }

  create(customRequestFormData: CustomRequestFormData) {
    return this.reflectUiAction({
      action: () => this._createRequest({
        customRequestFormData,
        projectId: this.project.id,
        companyId: this.companyId,
        currentUserId: this.currentUserId,
      }),
      actionSuccess: () => {
        this.$eventBus.emit(NOTIFICATION, Message.successMessage(customRequestCreatedMessage));
        this.$emit("customRequestCreated");
      }
    });
  }

  private async _createRequest({
     customRequestFormData,
     projectId,
     companyId,
     currentUserId
   }: CreateRequestArgs): Promise<void> {

    const {
      description,
      skills,
      jobTitle,
    } = customRequestFormData;

    const data: Custom_Request_Insert_Input = {
      project_id: projectId,
      description,
      company_id: companyId,
      created_by_id: currentUserId,
      job_title: jobTitle,
      custom_request_skills: {
        data: skills.map(skillId => ({ skill_id: Number(skillId) })),
      },
    };

    await this.$apollo.mutate({
      mutation: CREATE_CUSTOM_REQUEST,
      variables: {
        object: data,
      }
    });
  }

  private async reflectUiAction({ action, actionSuccess }: ReflectUiActionArgs): Promise<void> {
    if (this.processing) {
      return;
    }

    this.processing = true;

    try {
      await action();
      actionSuccess();
      this.modalShown = false;
    } catch (_) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage("Something went wrong!"));
    } finally {
      this.processing = false;
    }
  }
}
